import { render, staticRenderFns } from "./lay-head.vue?vue&type=template&id=1de75f38&scoped=true"
import script from "./lay-head.vue?vue&type=script&lang=js"
export * from "./lay-head.vue?vue&type=script&lang=js"
import style0 from "./lay-head.vue?vue&type=style&index=0&id=1de75f38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de75f38",
  null
  
)

export default component.exports